import React, { useState } from "react";
import { Dropdown, DropdownHeader, Navbar } from "flowbite-react";
import images from "../assets/images";
// import { advStaticObj } from "../constants/advertiserStaticData";
import { useLocation } from "react-router-dom";
import { HiSearch } from "react-icons/hi";

export const NavbarComponent = ({
  onToggleSidebar,
  advertisersList,
  setAdvertiserId,
  advertiserId,
  setSelectedAdvertiser,
  setAdvLogo,
  selectedAdvertiser,
  advLogo,
  // setStartDate,
  // setEndDate,
  setDataIngestionStatus,
  setGoogleIngestionStatus,
  setOptIngestionStatus,
  isOpen,
  setMetaFollowers,
  setInsFollowers,
  meta_followers,
  insta_followers,
  // search,
  // setSearch,
  onSearchChange,
}) => {
  // const [isCollapsed, setIsCollapsed] = useState(false);

  // const toggleSidebar = () => {
  //   localStorage.setItem("toggleSidebar");
  //   setIsCollapsed(!isCollapsed);
  // };
  const [localSearch, setLocalSearch] = useState("");

  const stopPropagation = (e) => e.stopPropagation();
  const handleKeyDown = (e) => {
    stopPropagation(e);
  };
  const handleSearch = (e) => {
    setLocalSearch(e.target.value);
    onSearchChange?.(e.target.value);
  };
  const location = useLocation();
  const handleChange = (data) => {
    localStorage.setItem("currentAdv", JSON.stringify(data));
    setAdvLogo(data.logo);
    setAdvertiserId(data.advertiser_id);
    setSelectedAdvertiser(data?.advertiser_name);
    // setStartDate(data?.advertiser_data_config_details[0]?.start_date);
    // setEndDate(data?.advertiser_data_config_details[0]?.end_date);
    setMetaFollowers(data?.advertiser_data_config_details?.[0]?.meta_followers);
    setInsFollowers(data?.advertiser_data_config_details?.[0]?.insta_followers);
    setDataIngestionStatus(data?.data_ingestion_statuses[0]?.status);
    setGoogleIngestionStatus(data?.google_data_ingestion_statuses[0]?.status);
    setOptIngestionStatus(data?.opti_data_ingestion_statuses[0]?.status);
  };

  // const currentAdv = advStaticObj[advertiserId]?.followers;
  // const metaFollowers =
  //   currentAdv?.fb || `@${selectedAdvertiser} • ${meta_followers} followers`;
  // const instaFollowers =
  //   currentAdv?.ins || `@${selectedAdvertiser} • ${insta_followers} followers`;
  const metaFollowers = `@${selectedAdvertiser} • ${meta_followers} followers`;
  const instaFollowers = `@${selectedAdvertiser} • ${insta_followers} followers`;
  // const defaultData = {
  //   fb: `@${selectedAdvertiser} • 11.1M followers`,
  //   ins: `@${selectedAdvertiser} • 5.3M followers`,
  // };
  return (
    <>
      <Navbar
        fluid
        className="sticky top-0 z-[11] w-full bg-white border-b border-gray-200 dark:bg-gray-800 dark:border-gray-700"
      >
        <div className="startMenuSec flex flex-1 w-full items-start">
          <div className="flex-1">
            <div className="flex gap-3 items-start w-full">
              <figure className="clientLogo max-h-10 max-w-10 md:max-w-12 xl:max-w-12 lg:max-w-12 overflow-hidden rounded">
                <img className="object-cover" src={advLogo} alt="logo" />
              </figure>
              <div className="detailsContent flex flex-col justify-between font-inter">
                <div className="flex gap-2 items-center mb-1">
                  <h4 className="2xl:text-xl text-sm font-medium dark:text-neutral-50 whitespace-nowrap text-nowrap">
                    {selectedAdvertiser}
                  </h4>
                  {/* <div className="dropdown link font-normal 2xl:text-lg text-sm text-sky-600 cursor-pointer items-center flex py-0 px-2 rounded-md">
                    <HiLink className="text-blue-600" />
                  </div> */}
                </div>
                {advertiserId !== "d70c297a-558d-40f1-9360-8d4a5c175a92" &&
                  location.pathname !== "/google-audit" && (
                    <div className="flex 2xl:text-sm xl:text-xs text-sm text-neutral-500 dark:text-neutral-200 items-center flex-wrap">
                      <div className="flex items-start gap-1">
                        {meta_followers && (
                          <>
                            <img
                              src={images.faceBook}
                              alt={metaFollowers}
                              title={metaFollowers}
                            />
                            <span className="hidden md:inline text-xs font-normal text-gray-600 font-inter md:mr-3">
                              {metaFollowers}
                            </span>
                          </>
                        )}
                        {insta_followers && (
                          <>
                            <img
                              src={images.instagram}
                              alt={instaFollowers}
                              title={instaFollowers}
                            />
                            <span className="hidden md:inline text-xs font-normal text-gray-600 font-inter">
                              {instaFollowers}
                            </span>
                          </>
                        )}
                      </div>
                      {/* <a
                    href="dropdown link font-normal 2xl:text-sm xl:text-xs md:text-1xs text-sky-600 cursor-pointer items-center flex hover:bg-blue-50 duration-75 py-1 px-2 rounded-md"
                    className=""
                  >
                    store
                  </a> */}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>

        <div className="rightSec">
          <Dropdown
            className="customDropdown"
            label={selectedAdvertiser || "Advertiser"}
          >
            <DropdownHeader className="sticky top-0 z-10 bg-white dark:bg-gray-800 w-full border-b">
              <div className="absolute inset-y-0 left-4 flex items-center pl-3 pointer-events-none">
                <HiSearch className="w-4 h-4 text-gray-500 dark:text-gray-400" />
              </div>
              <input
                type="text"
                name="search"
                className="block w-40 p-2 pl-9 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                placeholder="Search"
                value={localSearch}
                onChange={handleSearch}
                onKeyDown={handleKeyDown}
                onClick={stopPropagation}
              />
            </DropdownHeader>
            {advertisersList
              ?.filter((elem) => elem.is_active)
              ?.map((elem) => (
                <Dropdown.Item
                  className="w-full"
                  key={elem.id}
                  onClick={() => handleChange(elem)}
                >
                  {elem.advertiser_name}
                </Dropdown.Item>
              ))}
          </Dropdown>
        </div>
      </Navbar>
    </>
  );
};
